<!-- table-controls.component.html -->
<div class="bg-light-orange w-full flex items-center justify-between space-x-3 pr-3 pt-4 text-sm" [ngClass]="[marginTop, customClass]">
  <!-- Left side: Limit control -->
  <div 
    *ngIf="showLimitControl" 
    class="flex items-center pl-6" 
    [formGroup]="limitForm"
  >
    <div class="orange-text text-xs">Show</div>
    <input 
      class="orange-input focus:outline-none text-center mx-1 w-25-px text-xs p-1" 
      type="number" 
      formControlName="limit" 
      (change)="onLimitChange($event)"
      [value]="currentLimit"
    >
    <div class="orange-text text-xs">entries</div>
  </div>

  <!-- Spacer if limit control is hidden -->
  <div *ngIf="!showLimitControl"></div>

  <!-- Right side: Search control -->
  <div 
    *ngIf="showSearchControl"
    class="flex items-center space-x-3 pr-3" 
    [formGroup]="searchForm" 
    (keydown)="onKeyDown($event)"
  >
    <div class="orange-text text-xs">Search:</div>
    <div style="position: relative; display: flex; align-items: center;">
      <input 
        class="orange-input focus:outline-none pl-1 text-xs p-1"
        style="padding-right: 18px;"
        type="text" 
        [placeholder]="searchPlaceholder" 
        formControlName="search"
        (keyup)="onSearchKeyup($event)"
      >
      <span
        *ngIf="searchForm.get('search').value"
        (click)="clearSearch()"
        style="
          position: absolute;
          right: 8px;
          cursor: pointer;
          font-size: 13px;
          color: #999;
          line-height: 1;
          user-select: none;
        "
        class="material-icons"
      >
        search_off
      </span>
    </div>
  </div>
</div>